module.exports = __webpack_public_path__ + "static/media/coming_online.20f6f1cf.png";